import React from 'react'
import injectSheet from 'react-jss'

const NotFound = (props) => {
  const {
    classes,
  } = props

  return (
    <div className={`${classes.container}`}>
      <h2>NotFound</h2>
    </div>
  )
}

const styles = theme => ({
  container: {
    padding: `0px ${theme.sizes.gutter / 2}px`,
    height: '100%',
  },
})

export default injectSheet(styles)(NotFound)



// WEBPACK FOOTER //
// ./src/modules/core/components/notFound.jsx